import Autosuggest from "react-autosuggest";
import React from "react";

import SiteIcons from "../assets/SiteIcons";

let courseData = undefined;
const SearchData = [];

const SetcourseData = data => {
  courseData = data;
  GetSearchData(courseData);
};

const GetSearchData = theData => {
  theData.forEeach((sData, idx) => {
    const MySearchData = [];
    MySearchData.push(sData.entry_id);
    const SearchText = sData.en_us_lesson_name + " " + sData.lesson_description;
    MySearchData.push(SearchText);
    SearchData.push(MySearchData);
  });
};

function escapeRegexCharacters(str) {
  return str.replace(/[.*+?^${}()|[\]\\]/g, "\\$&");
}

function getSuggestions(value) {
  if (value !== undefined) {
    const escapedValue = escapeRegexCharacters(value.trim());

    if (escapedValue === "") {
      return [];
    }

    const regex = new RegExp(escapedValue, "i");

    return SearchData.filter(searchData => regex.test(searchData[1]));
  }
}

function getSuggestionValue(suggestion) {
  return suggestion[0];
}

function renderSuggestion(suggestion) {
  let theCourseID = suggestion[0];
  let myIndex;

  courseData.map((course, idx) => {
    if (course.entry_id == theCourseID) {
      myIndex = idx;
    }
  });
  let bgImageStyle;

  if (courseData[myIndex].screenshot !== undefined) {
    bgImageStyle = {
      backgroundImage:
        "url(https://assets.lmscourses.com/lesson-screenshots/" +
        courseData[myIndex].screenshot +
        ")"
    };
  }

  const AddToReport = courseData[myIndex].add_to_report.split("|");
  const Languages = ["English"];

  if (AddToReport.includes("Spanish")) {
    Languages.push("Spanish");
  }

  if (AddToReport.includes("French")) {
    Languages.push("French");
  }

  return (
    <div className="courseContainer">
      <div className="course">
        <div className="courseScreenshotContainer">
          <div className="courseThumbArea" style={bgImageStyle}></div>
        </div>
        <div className="courseDetails">
          <h1>{courseData[myIndex].en_us_lesson_name}</h1>
          <div className="courseSpecDetails">
            <span className="duration">
              <SiteIcons icon="time" />
              <span>
                {courseData[myIndex].lesson_hours}:
                {courseData[myIndex].lesson_minutes}
              </span>
            </span>
            <span className="languages">
              <SiteIcons icon="languages" />
              {Languages.map((lan, idx) => {
                let langComma = "";
                let langLength = Languages.length - 1;

                if (idx !== langLength) {
                  langComma = ",";
                }

                return (
                  <span key={idx}>
                    {lan}
                    {langComma}
                  </span>
                );
              })}
            </span>
          </div>
          <p>{courseData[myIndex].lesson_description}</p>
        </div>
      </div>
    </div>
  );
}

class SearchForm extends React.PureComponent {
  constructor() {
    super();
    this.state = {
      value: "",
      suggestions: []
    };
  }

  componentDidUpdate() {
    if (this.props.jsonData.length > 0) {
      //console.log('this.props.jsonData')
      if (courseData === undefined) {
        SetcourseData(this.props.jsonData);
      }
    }
  }

  onChange = (event, { newValue, method }) => {
    if (newValue !== undefined) {
      this.setState({
        value: newValue
      });
    }
  };

  onSuggestionsFetchRequested = ({ value }) => {
    //console.log('fetch: ' + value);
    this.setState({
      suggestions: getSuggestions(value)
    });
  };

  onSuggestionsClearRequested = () => {
    this.setState({
      suggestions: []
    });
  };

  onKeyDown = event => {
    if (event.type === "keydown") {
      if (event.key == "Enter") {
        getSuggestions(this.state.value);
      }
    }
  };

  render() {
    const { value, suggestions } = this.state;
    const inputProps = {
      placeholder: "Search courses",
      value,
      onChange: this.onChange,
      onBlur: this.onChange,
      onKeyDown: this.onKeyDown
    };

    return (
      <div id="searchPageContainer">
        <Autosuggest
          suggestions={suggestions}
          onSuggestionsFetchRequested={this.onSuggestionsFetchRequested}
          onSuggestionsClearRequested={this.onSuggestionsClearRequested}
          getSuggestionValue={getSuggestionValue}
          renderSuggestion={renderSuggestion}
          inputProps={inputProps}
        />
      </div>
    );
  }
}

export default SearchForm;
